import allProduct from "./allProducts.js";
import {secureRandomInt} from "../../../../../utils/secureRandom";

const productData = [...allProduct];

const shuffle = (a) => {
   for (let i = a.length; i; i--) {
      const j = secureRandomInt(i);
      [a[i - 1], a[j]] = [a[j], a[i - 1]];
   }
};

shuffle(productData);

export default productData;
